import { Suspense } from 'react';
import { RentalConfigurationTable, VenueRentalVersionSelect } from '@features';
import { Center, Skeleton, Stack } from '@mantine/core';

export const VenueDetailsRentalPage: React.FC = () => {
  return (
    <Stack py="md" gap="xl">
      <Center>
        <Suspense fallback={<Skeleton height={40} w={200} />}>
          <VenueRentalVersionSelect />
        </Suspense>
      </Center>
      <RentalConfigurationTable />
    </Stack>
  );
};
